import React from 'react';
import BaseIcon from './BaseIcon';

interface ArrowRightOnRectangleIconProps {
  className?: string;
}

const ArrowRightOnRectangleIcon: React.FC<ArrowRightOnRectangleIconProps> = ({ className }) => (
  <BaseIcon className={className}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16 17 21 12 16 7"></polyline>
    <line x1="21" y1="12" x2="9" y2="12"></line>
  </BaseIcon>
);

export default ArrowRightOnRectangleIcon;
